import "./PatientRightPanelMobileView.scss";
import { useState, useRef } from "react";
import { BED_DETAILS_MODULE, DEVICE_TYPES, DEVICE_LABELS } from "../../common/constant/common-constants";
import { useClickOutside } from "../../common/utils/CommonUtils";

import AlarmHistoryContainer from "../AlarmHistoryContainer/AlarmHistoryContainer";
import VitalDetailsContainer from "../VitalDetailsContainer/VitalDetailsContainer";
import { MODE } from "../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { VENTILATOR_ADDITIONAL_FEATURES } from "../../common/ENUMS/PARAMETER_ENUM";

import patientTypeAdult from "../../common/images/patient_type_adult.png";
import patientTypePediatric from "../../common/images/patient_type_pediatric.png";
import patientTypeNeonatal from "../../common/images/patient_type_neonatal.png";
import arrow from "../../common/images/Vector.png";
import WorkInProgress from "../../common/images/work-in-progress.png";

import goBack from "../../common/images/goBack.png";
import history from "../../common/images/history.png";
import waveform from "../../common/images/waveform.png";
import vitals from "../../common/images/vitals.png";



function PatientRightPanelMobileView(props) {
    const {
        bedId,
        activeSubHeader,
        handleSubHeaderClick,
        ventilatorConnected,
        user_enabled,
        ventilationStatus,
        activeVitalDevice,
        ventilatorPatientModeAlarmProfileData,
        ventilatorAdditionalFeaturesData,
        ventilatorModuleConnectionStatus,
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [monitoringVitalsView, setMonitoringVitalsView] = useState(false);
    const isVentilatorAvailable = !!props?.bedDetails?.ventilatorId;
    const isPMAvailable = !!props?.bedDetails?.Noccarc_patientMonitorId;
    const dropdownRef = useRef(null);
    useClickOutside(dropdownRef, () => setIsOpen(false), isOpen);
    //Additional Feature pop-up
    const data = ventilatorAdditionalFeaturesData;
    let activeFeatureLabel = null;
    if (
        activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS &&
        ventilatorConnected &&
        user_enabled &&
        ventilationStatus &&
        activeVitalDevice !== DEVICE_TYPES['NOCCARC_PM_NX5'] &&
        data?.length
    ) {
        const priority = [
            { id: VENTILATOR_ADDITIONAL_FEATURES?.o2_boost, label: <>O<sub>2</sub> Boost</> },
            { id: VENTILATOR_ADDITIONAL_FEATURES?.o2_suction, label: <>O<sub>2</sub> Suction</> },
            { id: VENTILATOR_ADDITIONAL_FEATURES?.inspiratory_hold, label: "Inspiratory Hold" },
            { id: VENTILATOR_ADDITIONAL_FEATURES?.expiratory_hold, label: "Expiratory Hold" },
            { id: VENTILATOR_ADDITIONAL_FEATURES?.nif, label: "NIF" },
            { id: VENTILATOR_ADDITIONAL_FEATURES?.p01, label: "P0.1" },
        ];

        const activeFeature = priority.find(feature =>
            data.find(f => f.id === feature.id && f.on)
        );

        activeFeatureLabel = activeFeature?.label || null;
    }

    // console.log("PatientRightPanelMobileView", props.config.userView)

    return (
        <div className="patient-right-panel-container-mobile-view">
            <div className="patient-right-panel-container-mobile-view-dynamic-island">
            </div>
            <div className="patient-right-panel-container-mobile-view-header">

                <div className="back-button">
                    <img className="patient-type" src={goBack} alt="<" onClick={props.handleCrossClick} />
                </div>
                <div className="bed-details-no">
                    Bed {props.bedDetails && props.bedDetails.bedName}
                </div>
                <div className="selected-device-type">
                    <div className="dropdown-container" ref={dropdownRef}>
                        <div
                            className="dropdown-trigger"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <div className="selected-device">
                                {DEVICE_LABELS[props.config.activeDevice]}
                            </div>
                            <img className="dropdown-arrow" src={arrow} alt="▼" />
                        </div>

                        {isOpen && (
                            <div className="dropdown-menu">
                                {/* Patient Monitor */}
                                <div
                                    className={`dropdown-item 
                    ${props.config.activeDevice === DEVICE_TYPES.NOCCARC_PM_NX5 ? "selected" : ""}
                    ${!isPMAvailable ? "disabled" : ""}
                `}
                                    onClick={() => {
                                        if (!isPMAvailable) {
                                            console.log("Patient Monitor not configured");
                                            return;
                                        }
                                        props.activeDeviceAction(DEVICE_TYPES.NOCCARC_PM_NX5);
                                        setIsOpen(false);
                                    }}
                                >
                                    {DEVICE_LABELS[DEVICE_TYPES.NOCCARC_PM_NX5]}
                                </div>

                                {/* Ventilator */}
                                <div
                                    className={`dropdown-item 
                    ${props.config.activeDevice === DEVICE_TYPES.VENTILATOR ? "selected" : ""}
                    ${!isVentilatorAvailable ? "disabled" : ""}
                `}
                                    onClick={() => {
                                        if (!isVentilatorAvailable) {
                                            console.log("Ventilator not configured");
                                            return;
                                        }
                                        props.activeDeviceAction(DEVICE_TYPES.VENTILATOR);
                                        setIsOpen(false);
                                    }}
                                >
                                    {DEVICE_LABELS[DEVICE_TYPES.VENTILATOR]}
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
            {props.config.activeDevice == DEVICE_TYPES.VENTILATOR ? (
                <>
                    <div className="patient-right-panel-container-mobile-view-additional-features">
                        <div className="patient-right-panel-container-mobile-view-mode-details">

                            <div className="mode-title">
                                Mode
                            </div>
                            <div className="mode-name">
                                {
                                    ventilatorConnected && user_enabled
                                        ? (MODE[ventilatorPatientModeAlarmProfileData?.modeId]?.modeName || "-")
                                        : "-"
                                }
                            </div>

                        </div>
                        <div className="patient-right-panel-container-mobile-view-active-modules">
                            <div className="active-modules-title">
                                Active Modules
                            </div>
                            <div className="active-modules-name">
                                {
                                    [
                                        (ventilatorConnected && user_enabled && ventilationStatus &&
                                            ventilatorAdditionalFeaturesData?.find(
                                                (f) => f.id === VENTILATOR_ADDITIONAL_FEATURES?.capnography
                                            )?.on)
                                            ? "CO2"
                                            : null,

                                        (ventilatorConnected && user_enabled && ventilationStatus &&
                                            ventilatorModuleConnectionStatus?.spo2)
                                            ? "SPO2"
                                            : null,

                                        (ventilatorConnected && user_enabled && ventilationStatus &&
                                            ventilatorAdditionalFeaturesData?.find(
                                                (f) => f.id === VENTILATOR_ADDITIONAL_FEATURES?.pnumetic_nebulizer
                                            )?.on)
                                            ? "Jet Neb"
                                            : null,

                                        (ventilatorConnected && user_enabled && ventilationStatus &&
                                            ventilatorAdditionalFeaturesData?.find(
                                                (f) => f.id === VENTILATOR_ADDITIONAL_FEATURES?.aerogen_nebulizer
                                            )?.on)
                                            ? "Mesh Neb"
                                            : null
                                    ]
                                        .filter(Boolean)
                                        .join(" | ") || "No Active Modules"
                                }
                            </div>
                        </div>
                    </div>
                    <div className="patient-right-panel-container-mobile-view-container">
                        {activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS &&
                            <VitalDetailsContainer
                                bedId={bedId}
                                monitorEcgWaveFormData={props.monitorEcgWaveFormData}
                                monitorRespWaveFormData={props.monitorRespWaveFormData}
                                monitorPlethWaveFormData={props.monitorPlethWaveFormData}
                                monitorHeartBeatData={props.monitorHeartBeatData}
                                vitalData_ECG={props.monitorData_ECG && props.monitorData_ECG.vitals}
                                vitalData_SPO2={props.monitorData_SPO2 && props.monitorData_SPO2.vitals}
                                vitalData_NIBP={props.monitorData_NIBP && props.monitorData_NIBP.vitals}
                                vitalData_TEMP={props.monitorData_TEMP && props.monitorData_TEMP.vitals}
                                ventilatorModesData={props.ventilatorModesData}
                                alarmData={props.alarmData}
                                activeVitalDevice={props.config.activeDevice}
                                handleSeeAllAlarms={() => handleSubHeaderClick(BED_DETAILS_MODULE.ALARMS)}
                                monitoringVitalsView={monitoringVitalsView}
                            />
                        }
                        {activeSubHeader === BED_DETAILS_MODULE.ALARMS &&
                            <AlarmHistoryContainer
                                bedId={bedId}
                                ventilatorModesData={props.ventilatorModesData}
                                ventilatorAlarmData={props.ventilatorAlarmData}
                                alarmData={props.alarmData}
                                activeVitalDevice={props.config.activeDevice}
                                userView={props.config.userView}
                            />
                        }
                    </div>
                    <div className="patient-right-panel-container-mobile-view-options">
                        <div className="icon-container" onClick={() => {
                            handleSubHeaderClick(BED_DETAILS_MODULE.VITAL_DETAILS);
                            setMonitoringVitalsView(false);
                        }}>
                            <img src={waveform} alt="Waveform" width="20" />
                            <div className="icon-title">Waveform</div>
                        </div>
                        <div className="icon-container" onClick={() => {
                            handleSubHeaderClick(BED_DETAILS_MODULE.VITAL_DETAILS);
                            setMonitoringVitalsView(true);
                        }}>
                            <img src={vitals} alt="Vitals" width="20" />
                            <div className="icon-title">Vitals</div>
                        </div>
                        <div className="icon-container" onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.ALARMS)}>
                            <img src={history} alt="History" width="20" />
                            <div className="icon-title">History</div>
                        </div>

                    </div>
                </>
            ) : (
                <div className="coming-soon-container">
                    <img className="coming-soon-image" src={WorkInProgress} alt=" " />
                    <div className="coming-soon-text"> Patient Monitor - Not available </div>

                </div>
            )
            }
            {activeFeatureLabel && !monitoringVitalsView && (
                <div className="overlay-box-active-maneuvrs">
                    {activeFeatureLabel}
                </div>
            )}

        </div>
    );
}

export default PatientRightPanelMobileView;
